import { Switch } from '@react-spectrum/s2';

import type { IGCommentWatcherClassContent } from '../../../../../bridge/types/artifact.ts';

interface CommentWatcherModeRowProps {
	content: IGCommentWatcherClassContent;
	editable: boolean;
	onContentChange?: (updates: Record<string, unknown>) => void;
}

// The comment watcher defaults to automated (replies post without approval). An
// absent requires_review is treated as review-first everywhere it is read, so a
// legacy or pre-ship-draft watcher (no baked value) never shows as automated.
export const CommentWatcherModeRow = ({
	content,
	editable,
	onContentChange,
}: CommentWatcherModeRowProps) => {
	const reviewFirst = content.requires_review !== false;

	if (!editable) {
		return (
			<div className="glass-card-sm mb-4 flex flex-col gap-1 p-4">
				<span className="text-sm font-semibold text-(--text-primary)">
					{reviewFirst ? 'You review each reply' : 'Replies automatically'}
				</span>
				<span className="text-xs leading-[1.4] text-(--text-muted)">
					{reviewFirst
						? 'Each reply waits for your approval in a new chat or the For you pill.'
						: 'Bridgeway replies to matching comments automatically, without asking first.'}
				</span>
			</div>
		);
	}

	return (
		<div className="glass-card-sm mb-4 flex flex-col gap-2 p-4">
			<div className="flex items-start justify-between gap-3">
				<span className="text-sm font-semibold text-(--text-primary)">
					Automatic replies
				</span>
				<Switch
					isSelected={reviewFirst}
					onChange={(selected) =>
						onContentChange?.({ requires_review: selected })
					}
					isEmphasized
					size="M"
					aria-label="Review first"
				>
					Review first
				</Switch>
			</div>
			<p className="m-0 text-xs leading-[1.4] text-(--text-secondary)">
				{reviewFirst
					? "You'll review each reply in a new chat or the For you pill before it posts."
					: 'Bridgeway replies to matching Instagram comments on your account automatically, without asking first. Turn on Review first to approve each reply before it posts.'}
			</p>
		</div>
	);
};
